/**
 * theme — مدیریت حالت نمایش (روشن / تیره / خودکار).
 *
 * حالت انتخابی کاربر در localStorage با کلید `ui_theme` نگهداری می‌شود.
 * برای جلوگیری از «چشمک» هنگام بارگذاری، یک اسکریپت کوچک درون <head>
 * فایل public/index.html هم همین کلید را می‌خواند و data-theme را زودتر ست می‌کند.
 *
 * روی <html> دو صفت گذاشته می‌شود:
 *   - data-bs-theme  → حالت تیره‌ی بومی Bootstrap 5.3 (کارت، مودال، فرم، جدول، dropdown ...)
 *   - data-theme     → لایه‌ی src/assets/dark-theme.css برای سطوح سفارشی (sidenav، پس‌زمینه‌ی ورود ...)
 */

const KEY = "ui_theme"; // 'light' | 'dark' | 'auto'
export const THEME_MODES = ["light", "dark", "auto"];

function mq() {
    return typeof window !== "undefined" && window.matchMedia
        ? window.matchMedia("(prefers-color-scheme: dark)")
        : null;
}

function systemPrefersDark() {
    const m = mq();
    return !!(m && m.matches);
}

export function getStoredTheme() {
    try {
        const v = localStorage.getItem(KEY);
        return THEME_MODES.indexOf(v) !== -1 ? v : "auto";
    } catch (e) {
        return "auto";
    }
}

export function resolveTheme(mode) {
    if (mode === "dark") return "dark";
    if (mode === "light") return "light";
    return systemPrefersDark() ? "dark" : "light";
}

export function applyTheme(mode) {
    if (typeof document === "undefined") return;
    const resolved = resolveTheme(mode);
    const root = document.documentElement;
    root.setAttribute("data-theme", resolved);
    root.setAttribute("data-bs-theme", resolved); // حالت تیره‌ی بومی Bootstrap 5.3
    // رنگ نوار مرورگر روی موبایل
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
        meta.setAttribute("content", resolved === "dark" ? "#16171d" : "#f35b21");
    }
}

export function setTheme(mode) {
    const m = THEME_MODES.indexOf(mode) !== -1 ? mode : "auto";
    try {
        localStorage.setItem(KEY, m);
    } catch (e) {
        /* noop */
    }
    applyTheme(m);
    return m;
}

/** حالت بعدی در چرخه‌ی light → dark → auto → light */
export function nextThemeMode(mode) {
    const i = THEME_MODES.indexOf(mode);
    return THEME_MODES[(i + 1) % THEME_MODES.length];
}

export function initTheme() {
    applyTheme(getStoredTheme());
    const m = mq();
    if (!m) return;
    const handler = () => {
        if (getStoredTheme() === "auto") applyTheme("auto");
    };
    if (m.addEventListener) m.addEventListener("change", handler);
    else if (m.addListener) m.addListener(handler); // Safari قدیمی
}

export default {
    THEME_MODES,
    getStoredTheme,
    resolveTheme,
    applyTheme,
    setTheme,
    nextThemeMode,
    initTheme,
};
